'use strict';

define(['utils/helpers', 'utils/strings', 'utils/underscore'], function (utils, strings, _) {

    var Defaults = {
        //file: undefined,
        //label: undefined,
        //type: undefined,
        //androidhls : undefined,
        'default': false
    };

    var Source = function Source(config) {
        // file is the only hard requirement
        if (!config || !config.file) {
            return;
        }

        // 如果是手机，又发现是rtmp流或flv,　看看是否有fallbackfile
        if ((utils.isRtmp(config.file) || utils.isFlv(config.file)) && utils.isMobile() && config.fallbackfile && utils.isHls(config.fallbackfile)) {
            config.file = config.fallbackfile;
        }

        // pc上如果不支持isFlvjsSupported，且发现是flv或者hls, 则看看是否有fallbackfile
        if (!utils.isMobile() && !utils.isFlvjsSupported() && (utils.isHls(config.file) || utils.isFlv(config.file)) && config.fallbackfile) {
            config.file = config.fallbackfile;
        }

        var _source = _.extend({}, Defaults, config);

        // normalize for odd strings
        _source.file = strings.trim('' + _source.file);
        // 解码视频文件名
        _source.file = decodeURI(_source.file);
        _source.file = _source.file.replace('%3F', '?');
        _source.file = _source.file.replace('%3D', '=');
        _source.file = _source.file.replace('%2F', '/');

        // regex to check if mimetype is given
        var mimetypeRegEx = /^[^\/]+\/(?:x-)?([^\/]+)$/;

        // check if the source is rtmp
        if (utils.isRtmp(_source.file)) {
            _source.type = 'rtmp';
        } else if (mimetypeRegEx.test(_source.type)) {
            // if type is given as a mimetype
            _source.type = _source.type.replace(mimetypeRegEx, '$1');
        } else if (!_source.type) {
            _source.type = strings.extension(_source.file);
        }

        if (!_source.type) {
            return;
        }

        // normalize types
        switch (_source.type) {
            case 'm3u8':
            case 'vnd.apple.mpegurl':
                _source.type = 'hls';
                break;
            case 'dash+xml':
                _source.type = 'dash';
                break;
            case 'smil':
                _source.type = 'rtmp';
                break;
            // Although m4a is a container format, it is most often used for aac files
            // http://en.wikipedia.org/w/index.php?title=MPEG-4_Part_14
            case 'm4a':
                _source.type = 'aac';
                break;
        }

        // remove empty strings
        _.each(_source, function (val, key) {
            if (val === '') {
                delete _source[key];
            }
        });

        return _source;
    };

    return Source;
});


/*****************
 ** WEBPACK FOOTER
 ** ./src/js/playlist/source.js
 ** module id = 89
 ** module chunks = 0
 **/